<template>
  <div class="inner">
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">처방문의 상세</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <h2 class="page_title mt30">처방문답</h2>

            <table class="write">
              <colgroup>
                <col width="200" />
                <col width="30%" />
                <col width="200" />
                <col width="30%" />
              </colgroup>
              <tbody>
                <tr>
                  <th><span>문의사항</span></th>
                  <td colspan="3">
                    <span>{{formulaQnaInfo.inquiry_details}}</span>
                  </td>
                </tr>
                <tr>
                <th>카테고리</th>
                <td colspan="3">
                  <span>{{formulaQnaInfo.prescribe_category_nm}}</span>
                </td>
              </tr>
                <tr>
                  <th><span>주소증</span></th>
                  <td colspan="3">
                    <span>{{formulaQnaInfo.chief_complaint}}</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <h2 class="page_title mt30">환자 정보</h2>
            <div class="table_list">
              <table class="write">
                <colgroup>
                  <col width="200" />
                  <col width="30%" />
                  <col width="200" />
                  <col width="30%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>나이</th>
                    <td>
                      <span>{{formulaQnaInfo.age}}</span>
                    </td>
                    <th>성별</th>
                    <td>
                      <span>{{formulaQnaInfo.gender_nm}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>키</th>
                    <td>
                      <span>{{formulaQnaInfo.height}} cm</span>
                    </td>
                    <th>몸무게</th>
                    <td>
                      <span>{{formulaQnaInfo.weight}} kg</span>
                    </td>
                  </tr>
                  <tr>
                    <th>혈압</th>
                    <td>
                      <span>{{formulaQnaInfo.blood_pressure}}</span>
                    </td>
                    <th>맥박수</th>
                    <td>
                      <span>{{formulaQnaInfo.pulse_rate}} 회/분</span>
                    </td>
                  </tr>
                  <tr>
                    <th>사상체질</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.sasang_constitution}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>기왕력</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.past_medical_history}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>진맥</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.pulse_diagnosis}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>복진</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.abdominal_exam}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>대변</th>
                    <td>
                      <span>{{formulaQnaInfo.bowel_condition}}</span>
                    </td>
                    <th>소변</th>
                    <td>
                      <span>{{formulaQnaInfo.urinary_condition}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>한출</th>
                    <td>
                      <span>{{formulaQnaInfo.sweating_pattern}}</span>
                    </td>
                    <th>심계</th>
                    <td>
                      <span>{{formulaQnaInfo.palpitations}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>수면</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.sleep_condition}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>갈증</th>
                    <td>
                      <span>{{formulaQnaInfo.thirst}}</span>
                    </td>
                    <th>물 선호</th>
                    <td>
                      <span>{{formulaQnaInfo.water_preference}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>소화 상태</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.digestion_condition}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>식용</th>
                    <td>
                      <span>{{formulaQnaInfo.appetite}}</span>
                    </td>
                    <th>붓기</th>
                    <td>
                      <span>{{formulaQnaInfo.edema}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>한열</th>
                    <td>
                      <span>{{formulaQnaInfo.cold_heat_sensation}}</span>
                    </td>
                    <th>두통</th>
                    <td>
                      <span>{{formulaQnaInfo.headache}}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>기타</th>
                    <td colspan="3">
                      <span>{{formulaQnaInfo.etc}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <h2 class="page_title mt30">관리자 처리</h2>

            <div class="table_list">
              <table class="write">
                <colgroup>
                  <col width="200" />
                  <col width="30%" />
                  <col width="200" />
                  <col width="30%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>노출여부</th>
                    <td colspan="3">
                      <div class="form_select">
                        <b-form-select v-model="formulaQnaInfo.display_yn">
                          <b-form-select-option value="Y"
                            >노출</b-form-select-option
                          >
                          <b-form-select-option value="N"
                            >비노출</b-form-select-option
                          >
                        </b-form-select>

                        <button class="btn btn_md btn_darkbrown btn_right" @click="fn_save_display">저장</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 class="page_title mt30">처방 답변</h2>
            <ul
              class="search_filter p0 mb10"
              style="background-color: transparent; flex-wrap: nowrap"
            >
              <li class="w50">
                <p>등록자</p>
                <input
                  type="text"
                  placeholder="입력하세요"
                  class="form_control"
                  v-model="write_user_nm"
                />
              </li>
              <li class="w50">
                <p>내용</p>
                <input
                  type="text"
                  placeholder="입력하세요"
                  class="form_control w100"
                  v-model="comment_contents"
                />
              </li>
              <li><button class="btn btn_md btn_outline" @click="fn_comment_search">조회</button></li>
            </ul>
            <div class="table_list">
              <table class="list no_view">
                <colgroup>
                  <col width="200" />
                  <col width="*" />
                  <col width="200" />
                </colgroup>
                <thead>
                  <tr>
                    <th>등록자</th>
                    <th>답변</th>
                    <th>처리</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="formulaQnaComment.length == 0">
                      <td colspan="3"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr v-for="(item, index) in formulaQnaComment" :key="index">
                    <td>
                      <span>{{item.doctor_nm}}</span>
                    </td>
                    <td class="al">
                      <span>{{item.comment_contents}}</span>
                    </td>
                    <td>
                      <button class="icon icon_del" @click="fn_delete_comment(item.comment_seq)"></button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <Pagination /> -->
            </div>

            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_listPage">목록</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Pagination from "@/components/AdminPagination.vue"
import commonUtil from "@/mixin/commonUtil";

export default {
  name: "AdminMain",
  components: {
    Pagination,
  },
  mixins: [commonUtil],
  data() {
    return {
      formula_inquiry_seq : '',
      write_user_nm : '',
      comment_contents : '',
      formulaQnaInfo : {},
      formulaQnaComment : [],
      formulaQnaBestComment : {}
    }
  },
  created(){
    this.formula_inquiry_seq = this.$store.getters['detailSearchInfo/getSearchId'];

  },
  mounted(){
    this.fn_search();
  },
  methods : {
    fn_search(){

        //환자seq 정보 셋팅
        let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;

        //상세조회
        axios
            .post("/api/admin/contents/getformulaQnaMngtDetail", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.formulaQnaInfo = res.data.formulaQnaInfo;
                this.formulaQnaComment = res.data.formulaQnaComment;
                this.formulaQnaBestComment = res.data.bestComment;
            })
            .catch((err) => console.log(err));
            
    },
    fn_comment_search(){
      let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;
        param.write_user_nm = this.write_user_nm;
        param.comment_contents = this.comment_contents;

        //환자정보 상세조회
        axios
            .post("/api/admin/contents/getformulaQnaMngtComment", param)
            .then((res) => {
                this.formulaQnaComment = res.data.formulaQnaComment;
                this.formulaQnaBestComment = res.data.bestComment;
            })
            .catch((err) => console.log(err));
    },
    fn_save_display(){
      let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;

        //처방문답 노출 여부 처리
        axios
            .post("/api/admin/contents/saveformulaQnaDisplay", param)
            .then((res) => {
                alert("변경되었습니다.");
            })
            .catch((err) => console.log(err));
    },
        fn_delete_comment(comment_seq){
      let param = new Object();
        param.formula_inquiry_seq = this.formula_inquiry_seq;
        param.comment_seq = comment_seq;

        //처방문답 댓글 삭제
        axios
            .post("/api/admin/contents/deleteformulaQnaComment", param)
            .then((res) => {
                alert("삭제되었습니다.");
                this.fn_comment_search();
            })
            .catch((err) => console.log(err));
    },
    fn_move_listPage(){
      this.$store.dispatch('detailSearchInfo/setSearchId', '');
      this.$router.push("/admin/contents/formulaQnaMngt");
    },
  }
};
</script>
